import { useChartContext, getGradientFromColor, LinearGradientWithStops, DEFAULT_THEME_NAME } from '@shopify/polaris-viz-core';
import { jsx } from 'react/jsx-runtime';

const GRADIENT_ID = 'grad';
function GradientDefs({
  direction = 'vertical',
  id,
  seriesColors = [],
  size = '100%',
  gradientUnits
}) {
  const {
    theme
  } = useChartContext();
  return /*#__PURE__*/jsx("defs", {
    children: seriesColors.map((color, index) => {
      const gradId = getGradientDefId(theme, index, id);
      return /*#__PURE__*/jsx(Gradient, {
        color: color,
        direction: direction,
        gradientUnits: gradientUnits,
        id: gradId,
        size: size
      }, gradId);
    })
  });
}
function Gradient({
  id,
  color,
  direction,
  size,
  gradientUnits = 'userSpaceOnUse'
}) {
  const gradient = getGradientFromColor(color);
  const position = direction === 'vertical' ? {
    y1: size
  } : {
    x2: size
  };
  return /*#__PURE__*/jsx(LinearGradientWithStops, {
    gradient: gradient,
    gradientUnits: gradientUnits,
    id: id,
    ...position
  });
}
function getGradientDefId(theme = DEFAULT_THEME_NAME, index, id) {
  return [id, theme, index, GRADIENT_ID].join('-');
}

export { GradientDefs, getGradientDefId };
